import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { Application } from "../../clients/aasServerClient.generated";

//import { Tooltip } from "reactstrap";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";

interface Props {
  application: Application;
}

const StatusIndicator: React.SFC<Props> = ({ application, ...rest }) => {
  switch (application.status?.status) {
    case "Active":
      return (
          <>
        <OverlayTrigger
        key={"top"}
        placement={"top"}
        overlay={<Tooltip id={`status-${application.id}`}>Active</Tooltip>}
      >
        <div>
        <FontAwesomeIcon className="text-success" icon={["fal", "sync"]} />
        </div>
      </OverlayTrigger>{" "}
    </>

      );
    case "Suspended":
      return (
      

        <>
        <OverlayTrigger
          key={"top"}
          placement={"top"}
          overlay={<Tooltip id={`status-${application.id}`}>Suspended</Tooltip>}
        >
          <div>
          <FontAwesomeIcon
               className="text-secondary"
               icon={["fal", "pause-circle"]}
             />
          </div>
        </OverlayTrigger>{" "}
      </>
      );
    case "Error":
      return (


        <>
        <OverlayTrigger
          key={"top"}
          placement={"top"}
          overlay={<Tooltip id={`status-${application.id}`}>Error</Tooltip>}
        >
          <div>
          <FontAwesomeIcon
              className="text-danger"
              icon={["fal", "exclamation-circle"]}
             />
          </div>
        </OverlayTrigger>{" "}
      </>
      );
    case "Idle":
      return (


        <>
        <OverlayTrigger
          key={"top"}
          placement={"top"}
          overlay={<Tooltip id={`status-${application.id}`}>Idle</Tooltip>}
        >
          <div>
          <FontAwesomeIcon
               className="text-primary"
               icon={["fal", "check-circle"]}
             />
          </div>
        </OverlayTrigger>{" "}
      </>
      );
    default:
      return (
        <>
          <OverlayTrigger
            key={"top"}
            placement={"top"}
            overlay={<Tooltip id={`status-${application.id}`}>Unknown</Tooltip>}
          >
            <div>
              <FontAwesomeIcon
                className="text-muted"
                icon={["fal", "question-circle"]}
              />
            </div>
          </OverlayTrigger>{" "}
        </>
      );
  }
};

export default StatusIndicator;
